export default __webpack_public_path__ + "locales/zh-CN/Common.json?hash=409ce846f34df73113d25bffd405dc58";